import React from "react";
import { Route, Redirect } from "react-router-dom";

import { getRoles } from "../../utils/OktaHelpers";
import { isAuthorized } from "../../utils/RolesHelpers";

const PrivateRoute = ({
    allowedRoles,
    path,
    exact,
    component,
    redirect,
    forbidden,
}) => {
    return !forbidden &&
        (!allowedRoles || isAuthorized(allowedRoles, getRoles())) ? (
        <Route path={path} exact={exact} component={component} />
    ) : (
        <Route path={path}>
            <Redirect to={redirect || "/page-not-found"} />
        </Route>
    );
};
export default PrivateRoute;
